// extracted by mini-css-extract-plugin
export var grid = "_15-0";
export var span1 = "_15-2";
export var span10 = "_15-b";
export var span10L = "_15-z";
export var span10M = "_15-n";
export var span10Xl = "_15-1b";
export var span11 = "_15-c";
export var span11L = "_15-10";
export var span11M = "_15-o";
export var span11Xl = "_15-1c";
export var span12 = "_15-d";
export var span12L = "_15-11";
export var span12M = "_15-p";
export var span12Xl = "_15-1d";
export var span1L = "_15-q";
export var span1M = "_15-e";
export var span1Xl = "_15-12";
export var span2 = "_15-3";
export var span2L = "_15-r";
export var span2M = "_15-f";
export var span2Xl = "_15-13";
export var span3 = "_15-4";
export var span3L = "_15-s";
export var span3M = "_15-g";
export var span3Xl = "_15-14";
export var span4 = "_15-5";
export var span4L = "_15-t";
export var span4M = "_15-h";
export var span4Xl = "_15-15";
export var span5 = "_15-6";
export var span5L = "_15-u";
export var span5M = "_15-i";
export var span5Xl = "_15-16";
export var span6 = "_15-7";
export var span6L = "_15-v";
export var span6M = "_15-j";
export var span6Xl = "_15-17";
export var span7 = "_15-8";
export var span7L = "_15-w";
export var span7M = "_15-k";
export var span7Xl = "_15-18";
export var span8 = "_15-9";
export var span8L = "_15-x";
export var span8M = "_15-l";
export var span8Xl = "_15-19";
export var span9 = "_15-a";
export var span9L = "_15-y";
export var span9M = "_15-m";
export var span9Xl = "_15-1a";
export var stretch = "_15-1";